import {
  Card,
  CardBody,
  CardTitle,
} from 'design-react-kit/dist/design-react-kit';
import { UniversalLink } from '@plone/volto/components';

const FolderCard = ({ url, title }) => {
  return url && title ? (
    <div className="folder-card col-sm-12 col-md-12 col-lg-6 col-xl-5">
      <Card
        className="card card-teaser shadow p-4 mt-3 rounded attachment"
        noWrapper={false}
        tag="div"
      >
        <CardBody tag="div">
          <CardTitle tag="h5">
            <UniversalLink href={url}>{title}</UniversalLink>
          </CardTitle>
        </CardBody>
      </Card>
    </div>
  ) : null;
};

export default FolderCard;
